import React from 'react';
import './reports.css'
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import { setUser } from '../../redux/actions/AuthActions'
import Skeleton from 'react-loading-skeleton';
import moment from 'moment'
import { Spin, DatePicker, TreeSelect } from 'antd';
import 'moment/locale/ar';
import { CSVLink } from "react-csv"
import StatisticCard from '../../component/statisticCard/statisticCard';
const { TreeNode } = TreeSelect;

let headers = [
  { label: "الموظف", key: "employee" },
  { label: "اجمالى التسجيلات", key: "interestsCount" },
  { label: "الاتصالات الناجحه ", key: "completedCalls" },
  { label: "النسبه", key: "completedCallsRatio" },
  { label: " لايوجد رد", key: "noReplyCalls" },
  { label: "النسبه", key: "noReplyCallsRatio" },
  { label: " التحديثات", key: "updatedCount" },
  { label: "النسبه", key: "updatedCountRatio" },
  { label: " الطلبات", key: "requestsCount" },
  { label: "النسبه", key: "requestsCountRatio" },
  { label: " صفقات الاهتمام", key: "pruchesedFromInterestsCount" },
  { label: "النسبه", key: "pruchesedFromInterestsRatio" },
  { label: "المحوله لزيارات", key: "visitingsCount" },
  { label: "النسبه", key: "visitingsCountRatio" },
  { label: " زيارات  تحولت الى طلب", key: "requestsFromvisitingsCount" },
  { label: " زيارات تحولت الى لا يرغب", key: "notInterestedFromvisitingsCount" },
  { label: "زيارات تحولت الى صفقه", key: "notInterestedFromvisitingsCount" },
  { label: " زيارات مباشره", key: "directVisitingsCount" },
  { label: " صفقات مباشره", key: "directDeals" },
  { label: "المبيعات", key: "totalSales" }
];
let csvData = [];
class reports extends React.Component {
  state = {
    csvData: [],
    count: [],
    loading: false,
    employees: [],
    startDate: null,
    endDate: null,
    daysDiff: 1,
    cities: [],
    workingCity: "ALL",
    salesTeams: [],
  }
  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
      moment.locale('ar');
    } else {
      allStrings.setLanguage('en')
      moment.locale('en');
    }
  }
  componentDidMount() {
    this.fetchAllData()
    this.getCities(1)
    this.getSalesTeamsWithoutPagenation()
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/${country}/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log(response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log("ALL cities ERROR")
        console.log(error.response)
      })
  }
  getSalesTeamsWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}salesTeams/withoutPagenation/get`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    }).then(response => {
      console.log(response.data.data)
      this.setState({ salesTeams: response.data.data })
    })
      .catch(error => {
        console.log("ALL salesTeams ERROR")
        console.log(error.response)
      })
  }
  onStartDateChange = (date) => {
    this.setState({
      startDate: date ? date.locale("en").format("YYYY-MM-DD") : null
    }, () => {
      this.fetchAllData();
    });
  }
  onStartDateChange = (date) => {
    const formattedStart = date ? date.locale("en").format("YYYY-MM-DD") : null;
    let daysDiff = 0;
    if (formattedStart && this.state.endDate) {
      daysDiff = moment(this.state.endDate).diff(moment(formattedStart), 'days');
    }
    this.setState({
      startDate: formattedStart,
      daysDiff: daysDiff > 0 ? daysDiff : 1
    }, () => {
      this.fetchAllData();
    });
  };
  onEndDateChange = (date) => {
    const formattedEnd = date ? date.locale("en").format("YYYY-MM-DD") : null;
    let daysDiff = 0;
    if (this.state.startDate && formattedEnd) {
      daysDiff = moment(formattedEnd).diff(moment(this.state.startDate), 'days');
    }
    this.setState({
      endDate: formattedEnd,
      daysDiff: daysDiff > 0 ? daysDiff : 1
    }, () => {
      this.fetchAllData();
    });
  };
  fetchAllData = () => {
    this.getInterestsReports();
    this.getEmployeesReport();
  }
  getInterestsReports = () => {
    const { startDate, endDate } = this.state;
    axios.get(`${BASE_END_POINT}admin/getInterestsReports`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
      params: { startDate, endDate }
    })
      .then(response => {
        this.setState({ count: response.data, loading: false })
      })
      .catch(error => {
        console.log("ALL count ERROR", error.response)
      })
  }
  getEmployeesReport = (value = null, type = null) => {
    const { startDate, endDate } = this.state;
    let params = { startDate, endDate }
    if (type === "WORKING-CITY") {
      params.workingCity = value
    }
    if (type === "SALES-TEAM") {
      params.salesTeam = value
    }
    axios.get(`${BASE_END_POINT}admin/getEmployeesReport`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
      params: params
    })
      .then(response => {
        console.log(response.data.data)
        this.setState({ employees: response.data.data })
        csvData = response.data.data.map(item => {
          return {
            ...{ employee: item.employee.fullname },
            ...{ interestsCount: item.currentInterestsCount },
            ...{ completedCalls: item.completedCalls },
            ...{ completedCallsRatio: item.completedCallsRatio },
            ...{ noReplyCalls: item.noReplyCalls },
            ...{ noReplyCallsRatio: item.noReplyCallsRatio },
            ...{ updatedCount: item.updatedCount },
            ...{ updatedCountRatio: item.updatedCountRatio },
            ...{ requestsCount: item.requestsCount },
            ...{ requestsCountRatio: item.requestsCountRatio },
            ...{ pruchesedFromInterestsCount: item.pruchesedFromInterestsCount },
            ...{ pruchesedFromInterestsRatio: item.pruchesedFromInterestsRatio },
            ...{ visitingsCount: item.visitingsCount },
            ...{ visitingsCountRatio: item.visitingsCountRatio },
            ...{ directVisitingsCount: item.directVisitingsCount },
            ...{ requestsFromvisitingsCount: item.requestsFromvisitingsCount },
            ...{ notInterestedFromvisitingsCount: item.notInterestedFromvisitingsCount },
            ...{ pruchesedFromVisitingsCount: item.pruchesedFromVisitingsCount },
            ...{ directDeals: item.directDeals },
            ...{ totalSales: item.totalSales },
          };
        });
        this.setState({ csvData: csvData, isReady: true })
      })
      .catch(error => {
        console.log("ALL employees ERROR", error.response)
      })
  }
  render() {
    const { loading } = this.state;
    return (
      <div className="reports">
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
          <MDBContainer>
            <MDBRow>
              <div style={{
                textAlign: this.props.isRTL ? 'right' : 'left',
                flexDirection: this.props.isRTL ? 'row' : 'row-reverse',
                display: this.props.isRTL ? '' : 'flex',
                width: this.props.isRTL ? '100%' : '', padding: '5px 20px 25px'
              }}>
                <span style={{
                  display: 'inline-block',
                  color: '#43425D',
                  fontSize: '22px'
                }}>{this.state.daysDiff == 1 ? allStrings.theDay : ' يوم ' + this.state.daysDiff}</span>
                <span style={{
                  fontWeight: 'bold', fontSize: '22px', display: 'inline-block',
                  color: '#43425D', margin: '6px', lineHeight: this.props.isRTL ? 'auto' : '15px'
                }}>|</span>
                <span style={{
                  fontWeight: 'bold', fontSize: '22px', display: 'inline-block',
                  color: '#43425D'
                }}>{allStrings.statistic}</span>
              </div>
            </MDBRow>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <MDBCol md="4" sm="6">
                <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{this.props.isRTL ? "من تاريخ" : "From Date"}</label>
                <DatePicker
                  onChange={this.onStartDateChange}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  placeholder={this.props.isRTL ? 'من تاريخ' : 'Start Date'}
                />
              </MDBCol>
              <MDBCol md="4" sm="6">
                <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{this.props.isRTL ? "إلى تاريخ" : "To Date"}</label>
                <DatePicker
                  onChange={this.onEndDateChange}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                  placeholder={this.props.isRTL ? 'إلى تاريخ' : 'End Date'}
                />
              </MDBCol>
            </MDBRow>
            <br></br>
            <br></br>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row' : 'row-reverse' }}>
              <StatisticCard
                name={allStrings.interests}
                value={this.state.count.interestsCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.requests}
                value={this.state.count.requestsCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.completedCalls}
                value={this.state.count.completedCalls}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.noReplyCalls}
                value={this.state.count.noReplyCalls}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.updatedCount}
                value={this.state.count.updatedCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.visitingsCount}
                value={this.state.count.visitingsCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              {/* <StatisticCard
                name={allStrings.bookingCount}
                value={this.state.count.bookingCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.completedDeals}
                value={this.state.count.completedDeals}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.unCompletedDeals}
                value={this.state.count.unCompletedDeals}
                isRTL={this.props.isRTL}
                loading={loading}
              /> */}


              <StatisticCard
                name={allStrings.soldCount}
                value={this.state.count.soldCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.bookingCount}
                value={this.state.count.bookedCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.dealsCount}
                value={this.state.count.dealsCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.investmentsCount}
                value={this.state.count.investmentsCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.completedCount}
                value={this.state.count.completedCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />
              <StatisticCard
                name={allStrings.deliveredCount}
                value={this.state.count.deliveredCount}
                isRTL={this.props.isRTL}
                loading={loading}
              />

            </MDBRow>
            <br></br>
            <br></br>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <MDBCol xl="12" lg="12" md="12" sm="12">
                <div className="theCard" style={{ minHeight: '50px' }}>
                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                    <MDBCol xl="2" lg="2" md="2" sm="12">
                      <p className="topCard" style={{ color: '#43425D', textAlign: this.props.isRTL ? 'right' : 'left' }}>{allStrings.employees}</p>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.workingCity}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ workingCity: value });
                          this.getEmployeesReport(value, 'WORKING-CITY')
                        }}

                      >
                        <TreeNode value="ALL" title={allStrings.all} key="ALL" />
                        <TreeNode value="CONTACT-TEAM" title={allStrings.contactTeam} key="CONTACT-TEAM" />
                        {this.state.cities.map(val => (
                          <TreeNode value={val.id} title={this.props.isRTL ? val.cityName_ar : val.cityName_en} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.salesTeam}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ salesTeam: value });
                          this.getEmployeesReport(value, 'SALES-TEAM')

                        }}

                      >
                        {this.state.salesTeams.map(val => (
                          <TreeNode value={val.id} title={val.name} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                    <MDBCol xl="2" lg="2" md="2" sm="12">
                      <CSVLink
                        data={this.state.csvData}
                        headers={headers}
                        filename={"reports.csv"}
                        style={{ padding: '10px', position: 'absolute', top: '0px' }}
                      >
                        <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                      </CSVLink>
                    </MDBCol>
                  </MDBRow>
                  <br></br>
                  <table className="table table-borderless">
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">{allStrings.totalSales}</th>
                        <th scope="col">{allStrings.directDeals}</th>
                        <th scope="col">{allStrings.directVisitingsCount}</th>
                        <th scope="col">{allStrings.ratio}</th>
                        <th scope="col">{allStrings.interestsVisitingsCount}</th>
                        <th scope="col">{allStrings.ratio}</th>
                        <th scope="col">{allStrings.interestsDeals}</th>
                        <th scope="col">{allStrings.ratio}</th>
                        <th scope="col">{allStrings.requests}</th>
                        <th scope="col">{allStrings.ratio}</th>
                        <th scope="col">{allStrings.updatedCount}</th>
                        <th scope="col">{allStrings.ratio}</th>
                        <th scope="col">{allStrings.noReplyCalls}</th>
                        <th scope="col">{allStrings.ratio}</th>
                        <th scope="col">{allStrings.completedCalls}</th>
                        <th scope="col">{allStrings.totalInterests}</th>
                        <th scope="col">{allStrings.employee}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loading ?
                        <div style={{ width: "100%" }} >
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                          <Skeleton height={40} />
                        </div>
                        :
                        this.state.employees.length > 0 ?
                          this.state.employees.map(val => (
                            <tr onClick={() => this.props.history.push("/userInfo", { data: val.employee })}>
                              <td style={{ direction: 'rtl' }}>{val.totalSales}</td>
                              <td style={{ direction: 'rtl' }}>{val.pruchesedFromDirectDealCount}</td>
                              <td style={{ direction: 'rtl' }}>{val.directVisitingsCount}</td>
                              <td style={{ direction: 'rtl' }}>{val.visitingsCountRatio}</td>
                              <td style={{ direction: 'rtl' }}>{val.visitingsCount}</td>
                              <td style={{ direction: 'rtl' }}>{val.pruchesedFromInterestsRatio}</td>
                              <td style={{ direction: 'rtl' }}>{val.pruchesedFromInterestsCount}</td>
                              <td style={{ direction: 'rtl' }}>{val.requestsCountRatio}</td>
                              <td style={{ direction: 'rtl' }}>{val.requestsCount}</td>
                              <td style={{ direction: 'rtl' }}>{val.updatedCountRatio}</td>
                              <td style={{ direction: 'rtl' }}>{val.updatedCount}</td>
                              <td style={{ direction: 'rtl' }}>{val.noReplyCallsRatio}</td>
                              <td style={{ direction: 'rtl' }}>{val.noReplyCalls}</td>
                              <td style={{ direction: 'rtl' }}>{val.completedCallsRatio}</td>
                              <td style={{ direction: 'rtl' }}>{val.completedCalls}</td>
                              <td style={{ direction: 'rtl' }}>{val.currentInterestsCount}</td>
                              <td>{val.employee.fullname}</td>
                            </tr>
                          ))
                          :
                          <tr style={{ height: '300px' }}>
                            <th colSpan="8" className="noData" style={{ background: "#fff" }}>
                              <p style={{ marginTop: '10rem', textAlign: 'center', }}>{allStrings.noData}</p>
                            </th>
                          </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </Spin>
      </div >
    )
  }
}
const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})
const mapDispatchToProps = {
  setUser,
  ChangeLanguage
}
export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(reports)
);